var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.378906 8.86032C0.378906 4.31021 4.10172 0.587402 8.65182 0.587402C13.2019 0.587402 16.9247 4.31021 16.9247 8.86032C16.9247 13.4104 13.2019 17.1332 8.65182 17.1332C4.10172 17.1332 0.378906 13.4104 0.378906 8.86032ZM9.27229 13.3587V9.01544H10.4615L10.6166 7.51597H9.27229V6.79209C9.27229 6.43015 9.324 6.22333 9.89276 6.22333H10.6166V4.72386H9.42741C7.97965 4.72386 7.5143 5.44774 7.5143 6.63697V7.51597H6.58359V9.01544H7.46259V13.3587H9.27229Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbLogo);
export default __webpack_public_path__ + "static/media/fb_logo.1fcee0beeca997955a9383204b9783a7.svg";
export { ForwardRef as ReactComponent };